import type { InstallmentPlanInvoiceData } from '@festina/moneyin-general-types/moneyin'
import { InvoicesService } from '@festina/moneyin-general-types/moneyin/services/InvoicesService'
import { useFestinaMutation } from '@festina-life/authentication'

const method = InvoicesService.installmentPlansServicePostCreateInstallmentPlan

export const useCreateInstallmentPlan = ({ tenantId }: { tenantId: string }) =>
  useFestinaMutation({
    component: 'moneyIn',
    roles:
      InvoicesService.installmentPlansServicePostCreateInstallmentPlan_roles,
    isScenario: false,
    mutateFunction: async (arg: InstallmentPlanInvoiceData) => {
      await method({ xTenantId: tenantId, requestBody: arg })
    },
  })
